export const BOOK_APPOINTMENT_SUCCESS = "BOOK_APPOINTMENT_SUCCESS";

export const BOOK_APPOINTMENT = "BOOK_APPOINTMENT";
